import { Navigate, Outlet } from "react-router-dom";
import { getStoredToken } from "../lib/authStorage";

const ProtectedRoute = () => {
  const token = getStoredToken();
  

  if (!token) {
    alert("Please sign in first");
    return <Navigate to="/SignIn"/>;
  }

  return <Outlet />;
};

export default ProtectedRoute;